
import generico from '@/generico.js'
import axios from "@/axios.js"
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import {Portuguese as PortugueseLocale} from 'flatpickr/dist/l10n/pt.js';
//import {english as EnglishLocale} from 'flatpickr/dist/l10n/default.js'
//import {Spanish as SpanishLocale} from 'flatpickr/dist/l10n/es.js'


export default {
    components: {
        AgGridVue,
        flatPickr
    },

    data() {
        return {
            senhaBloqueioDesbloqueio: null,
            filtroVeiculoSelecionadoBloqueio: null,

            filtroDataInicio: null,        
            filtroDataFim: null,      
            configDatePickerRelatorio: {          
                altInput: true,
                altFormat: "d-m-Y",
                dateFormat: "Y-m-d", 
                altInputClass: "vs-inputx vs-input--input normal hasValue small text-center w-full",
                locale: PortugueseLocale,  
                enableTime: false                
            }, 
            filtroVeiculoSelecionadoRelatorio: null,  

            avisoSelecionado: [],
            listaAvisos: [],
            listaTiposAviso: [],
            filtroVeiculoSelecionadoAviso: null,  
            filtroTipoAvisoSelecionado: null, 
            filtroDataAviso: null,      
            exibirMensagemNenhumDadoEncontrado: false,
            configDatePicker: {          
                altInput: true,
                altFormat: "d-m-Y",
                dateFormat: "U", 
                altInputClass: "vs-inputx vs-input--input normal hasValue ml-1",
                locale: PortugueseLocale
            },

            fullscreen: false,
            output: null,           
            listaContentStringInfowindow: new Map(),
            listaRastros: new Map(),
            markersPoI: new Map(),
            perimetrosDesenhados: new Map(),
            markerInfowindow: null,
            infowindow: null,
            pollingIntervalObj: null,
            switchEnderecoCidade: true,
            sohDesatualizados: false,
            sohParado: false,
            sohAlertaParado: false,
            termoPesquisa: null,
            popLocalizarVeiculosProximos: {
                exibir: false,
                listaEnderecos: [],
                markerInfowindowLocalizar: null,
                infowindowLocalizar: null,
                listaPosicaoVeiculos: null,
                listaPlacasVeiculos: null,
                mensagem: null,
                exibirMensagem: false
            },
            carroSelecionadoNoGrid: [],
            exibirGrid: true,           
            publicPath: process.env.BASE_URL
        }
    },
    beforeMount() {
        
    },
    created() {
        window.click_ExibiVeiculo = this.click_ExibiVeiculo;
        window.click_AbrirPopUpCriarPoI = this.click_AbrirPopUpCriarPoI;
        window.click_RoutePercurso = this.click_RoutePercurso;
        window.click_RoutePercursoNovaWindow = this.click_RoutePercursoNovaWindow;

        this.botaoImprimirDiv = null,
        this.botaoExibirTrafegoDiv = null;
        this.botaoAjustesDiv = null;
        this.botaoVerTodosDiv = null;
        this.botaoLocalizarEnderecoDiv = null;
        this.trafficLayer = null;
        this.map = null;
        this.mc = null;
    },
    mounted() {
        this.filtroDataInicio = generico.formatarTimestampParaYMDHifem(new Date().fp_incr(-7).getTime());
        this.filtroDataFim = generico.formatarTimestampParaYMDHifem(new Date().getTime());

        this.map = new window.google.maps.Map(document.getElementById('map'), {
            center: new window.google.maps.LatLng(-5, -42),
            gestureHandling: 'greedy',
            zoom: 8,
            controlSize: 20,
            fullscreenControl: true,
            fullscreenControlOptions: {
                position: window.google.maps.ControlPosition.LEFT_TOP
            },
            streetViewControl: false,
            zoomControl: true,
            zoomControlOptions: {
                position: window.google.maps.ControlPosition.LEFT_TOP
            },
            mapTypeControlOptions: {
                style: window.google.maps.MapTypeControlStyle.DEFAULT
            }
        });
        this.mc = new window.MarkerClusterer(this.map);
        this.mc.setMaxZoom(16);       
        this.inicializarMarcadores();
        this.exibirVeiculosListados();
        this.criarBotaoImprimir();        
        this.criarBotaoVerTodos();        
        this.criarBotaoOcultarGrid();
    },
    computed: {
        filteredVeiculosPossuiBloqueio: function () {
            var self = this;
            var arrayRetorno = self.listaVeiculos;  
            
            arrayRetorno = arrayRetorno.filter(function (veiculo) {            
                return veiculo.possuiBloqueio;
            })
    
            if (arrayRetorno === null) {
                return [];
            }
            
            return arrayRetorno;
        }, 
        queriedItems() {
            return this.$refs.table ? this.$refs.table.queriedResults.length : this.listaAvisos.length
        },
        qtdVeiculosFiltrados() {
            return this.$refs.table ? this.$refs.table.queriedResults.length : this.filteredVeiculos.length
        },
        corCadeado() {
            return {
                'text-white': (this.$store.state.theme === 'dark'),
                'text-black': (this.$store.state.theme === 'light'),
            }
        },
        listaVeiculos() {
            return this.$store.state.veiculos;
        },
        corLocalidades() {
            return this.$store.state.corLocalidade;
        },
        filteredVeiculos: function () {
            var self = this;
            var arrayRetorno = self.listaVeiculos;
            if (self.sohDesatualizados) {
                arrayRetorno = arrayRetorno.filter(function (veiculo) {
                    return veiculo.isDesatualizado;
                })
            }

            if (self.sohParado) {
                arrayRetorno = arrayRetorno.filter(function (veiculo) {
                    return (veiculo.ignicao == 'DESLIGADO' || (veiculo.ignicao == 'LIGADO' && veiculo.velocidadeAtual == '0'));
                })
            }

            if (self.sohAlertaParado) {
                arrayRetorno = arrayRetorno.filter(function (veiculo) {
                    return veiculo.hasOwnProperty("exibirAlertaTempoParado");
                })
            }

            if (self.termoPesquisa != null) {
                arrayRetorno = arrayRetorno.filter(function (veiculo) {
                    let termoUC = self.termoPesquisa.toUpperCase();
                    return (veiculo.marca.toUpperCase().indexOf(termoUC) != -1 || veiculo.modelo.toUpperCase().indexOf(termoUC) != -1 ||
                        veiculo.divisaoVeiculo.toUpperCase().indexOf(termoUC) != -1 || veiculo.cidadeAtual.toUpperCase().indexOf(termoUC) != -1 ||
                        veiculo.condutor.toUpperCase().indexOf(termoUC) != -1 || (veiculo.labelVeiculo && veiculo.labelVeiculo.toUpperCase().indexOf(termoUC) != -1)
                        || veiculo.placa.toUpperCase().indexOf(termoUC) != -1);
                })
            }

            return arrayRetorno;
        }        
    },
    beforeDestroy() {
        clearInterval(this.pollingIntervalObj);
        this.map = null;
        this.listaContentStringInfowindow = null;
        this.listaRastros = null;
        this.carroSelecionadoNoGrid = null;        
        this.markersPoI = null;                
        this.mc = null;
        this.botaoImprimirDiv = null,
        this.botaoVerTodosDiv = null;        
        this.botaoOcultarGridDiv = null;
        this.trafficLayer = null;
    },
    methods: {    
        enviarComando(comando) {
            this.$vs.loading();
            const params = new URLSearchParams();        
            params.append('outputFormat', 'JSON');
            params.append('comando', comando);
            params.append('idVeiculo', this.filtroVeiculoSelecionadoBloqueio.idVeiculo);
            params.append('origemComando', 'WEB');
            params.append('senhaContato', this.senhaBloqueioDesbloqueio);
            params.append('idCliente', this.$store.state.AppActiveUser.id);
            
            axios.post('/EnviarComandoModulo', params, {              
                    credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
            .then((response) => {
                this.$vs.loading.close();
                if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {                
                    this.$router.push({ path: '/login' });
                } else {                                
                    this.$vs.dialog({ color: 'danger', title: this.$t('Atencao'), text: response.data.mensagem, acceptText: this.$t('Btn_OK')})                
                }
            })
            .catch((error) => { 
                /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - gravar - " + error); 
                this.$vs.loading.close();
            }) 
        },
        pesquisarVeiculo(options, varTermoPesquisa) {
      
            varTermoPesquisa = varTermoPesquisa.toUpperCase();
            return options.filter(function (veiculo) {
                    return (veiculo.marca.toUpperCase().indexOf(varTermoPesquisa) != -1  || veiculo.modelo.toUpperCase().indexOf(varTermoPesquisa) != -1 || 
                    veiculo.placa.toUpperCase().indexOf(varTermoPesquisa) != -1 || veiculo.condutor.toUpperCase().indexOf(varTermoPesquisa) != -1 || 
                    (veiculo.labelVeiculo && veiculo.labelVeiculo.toUpperCase().indexOf(varTermoPesquisa) != -1)
                    ) ;
            })
        },   
        gerarRelatorio(pTipoFormato) {
            this.$vs.loading();

            let urlRelatorio = "/RelatorioUtilizacaoVeiculoAnalitico";
            const params = new URLSearchParams();                    

            let tsDataInicio = Date.UTC(this.filtroDataInicio.split('-')[0], this.filtroDataInicio.split('-')[1]-1, this.filtroDataInicio.split('-')[2], 0, 0,0);
            let tsDataFim = Date.UTC(this.filtroDataFim.split('-')[0], this.filtroDataFim.split('-')[1]-1, this.filtroDataFim.split('-')[2], 23, 59, 59);
            
            params.append('exportarTipo', pTipoFormato);
            params.append('dataInicio', tsDataInicio+3*60*60*1000);
            params.append('dataFim', tsDataFim+3*60*60*1000);        
            params.append('idCliente', this.$store.state.AppActiveUser.id);
            if (this.filtroVeiculoSelecionadoRelatorio) {
              params.append('placa', this.filtroVeiculoSelecionadoRelatorio.placa);
              params.append('idVeiculo', this.filtroVeiculoSelecionadoRelatorio.idVeiculo);
            } else {
              params.append('placa', '');
              params.append('idVeiculo', '');
            }
            params.append('pOrderBy', 'placa');

            axios.post(urlRelatorio, params, {              
                    credentials: 'include', responseEncoding: 'iso88591', withCredentials: true,  responseType: 'arraybuffer' } )
            .then((response) => {
                this.$vs.loading.close();
                if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {                
                    this.$router.push({ path: '/login' });  // Efetuar logoff
                } else {                                                
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', 'RelatorioRastreamento.pdf');
                    document.body.appendChild(fileLink);
                    fileLink.click();                    
                }
            })
            .catch(() => { 
                this.$vs.loading.close();
            }) 
        },
        exibirAvisosSelecionado(aviso) {                               
            var location = this.$refs.gmc.getLatLng(aviso.latitude, aviso.longitude);
            var marker1 = new window.MarkerWithLabel({
                position: location,
                 title: aviso.tipoDescricao + '\n' + aviso.condutor + '\n' + aviso.descricao + '\n' + aviso.dataHora,
                 map: this.map,                   
                 labelAnchor: new window.google.maps.Point(22, 0),       
                 labelStyle: {opacity: 1} ,
                 icon: { url: this.publicPath + 'imagens/iconesAvisos/dot' + aviso.tipo + '.png'}   
             });  

             setTimeout(function () {
                marker1.setMap(null);
                marker1 = null;                
            }, 2000);
                  
             
            this.map.setCenter(location);
            this.map.setZoom(25);            
        }, 
        fetchListaAviso() { 
            this.$vs.loading();
    
            const params = new URLSearchParams();
            params.append('outputFormat', 'JSON');
            params.append('idCliente', this.$store.state.AppActiveUser.id);
            params.append('idVeiculo', this.filtroVeiculoSelecionadoAviso.idVeiculo);
            if (this.filtroTipoAvisoSelecionado) {
              params.append('tipo', this.filtroTipoAvisoSelecionado.data);
            }
            if (this.filtroDataAviso) {
              params.append('dataHora', this.filtroDataAviso*1000);
            }
            
            axios.post("/ListarAvisosVeiculoClientePorData", params, {              
                    credentials: 'include',
                    responseEncoding: 'iso88591',
                    withCredentials: true } )
            .then((response) => {
                this.$vs.loading.close();
                if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                  this.$router.push({ path: '/login' });
                } else {
                    if (response.data.hasOwnProperty("lista")) {                    
                        this.listaAvisos = response.data.lista;
                        if (this.listaAvisos.length > 0) {
                          this.exibirMensagemNenhumDadoEncontrado = false;                                              
                        } else {
                          this.listaAvisos = null;
                          this.listaAvisos = [];
                          this.exibirMensagemNenhumDadoEncontrado = true;  
                        }
                    } else {
                        this.listaAvisos = null;
                        this.listaAvisos = [];
                        this.exibirMensagemNenhumDadoEncontrado = true;                    
                    }
                }
            })
            .catch((error) => { 
                /* eslint-disable no-console */   console.log("EFETUAR LOGOFF! - fetchListaAviso - " + error); 
            })    
                            
        },  
        toggleFullscreen(elem) {
            elem = document.getElementById('map') || document.documentElement;

            if (!document.fullscreenElement && !document.mozFullScreenElement &&
                !document.webkitFullscreenElement && !document.msFullscreenElement) {
                if (elem.requestFullscreen) {
                    elem.requestFullscreen();
                } else if (elem.msRequestFullscreen) {
                    elem.msRequestFullscreen();
                } else if (elem.mozRequestFullScreen) {
                    elem.mozRequestFullScreen();
                } else if (elem.webkitRequestFullscreen) {
                    elem.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
                }
            } else {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.webkitExitFullscreen) {
                    document.webkitExitFullscreen();
                }
            }
        },
        click_RoutePercurso(placaSelecionada) {
            let veiculoSelecionado = null;
            for (var i = 0; i < this.listaVeiculos.length; i++) {
                if (this.listaVeiculos[i].placa == placaSelecionada) {
                    veiculoSelecionado = this.listaVeiculos[i];
                    break;
                }
            }

            this.$router.push({
                name: "fast-percurso",
                params: {
                    pVeiculoSelecionado: veiculoSelecionado
                }
            })
        },
        click_RoutePercursoNovaWindow(placaSelecionada) {
            let veiculoSelecionado = null;
            for (var i = 0; i < this.listaVeiculos.length; i++) {
                if (this.listaVeiculos[i].placa == placaSelecionada) {
                    veiculoSelecionado = this.listaVeiculos[i];
                    break;
                }
            }

            let routeUrl = this.$router.resolve({
                name: "fast-percurso",
            });

            this.$store.commit('SET_DADOS_PARA_PERCURSO', { filtroVeiculoSelecionado: veiculoSelecionado, consolidadoPercursoSelecionado: null, dadosPopUpParametroHora: null });

            window.open(routeUrl.href, '_blank');
        },        
        mostrarInfowindowComDistancias(localizacaoMarker) {

            this.map.setCenter(localizacaoMarker);
            var marker1 = new window.google.maps.Marker({
                map: this.map,
                draggable: true,
                position: localizacaoMarker,
                icon: { url: this.publicPath + 'imagens/localizacaoEndereco.png' }
            });
            let self_ = this;

            window.google.maps.event.addListener(marker1, 'dragend', function () {
                marker1.setMap(null);
                self_.mostrarInfowindowComDistancias(marker1.getPosition());
            });

            this.popLocalizarVeiculosProximos.markerInfowindowLocalizar = marker1;

            if (this.map.getZoom() < 15) {
                this.map.setZoom(15);
            }

            this.popLocalizarVeiculosProximos.listaPosicaoVeiculos = [];
            this.popLocalizarVeiculosProximos.listaPlacasVeiculos = [];
            let marcadores = this.$refs.gmc.getMarcadores();

            for (i = 0; i < marcadores.length; i++) {
                this.popLocalizarVeiculosProximos.listaPosicaoVeiculos.push(marcadores[i].getPosition());
                if (marcadores[i].getTitle() != marcadores[i].labelContent) {
                    this.popLocalizarVeiculosProximos.listaPlacasVeiculos.push(marcadores[i].getTitle() + " - " + marcadores[i].labelContent);
                } else {
                    this.popLocalizarVeiculosProximos.listaPlacasVeiculos.push(marcadores[i].getTitle());
                }
            }

            var distances = [];
            for (var i = 0; i < this.popLocalizarVeiculosProximos.listaPosicaoVeiculos.length; i++) {
                distances.push({ distance: window.google.maps.geometry.spherical.computeDistanceBetween(this.popLocalizarVeiculosProximos.listaPosicaoVeiculos[i], localizacaoMarker), marker1: i, marker2: 0 });
            }

            distances.sort(function (a, b) {
                return a.distance - b.distance;
            });

            let listaPosicaoVeiculosFiltrada = [];
            let listaPlacasVeiculosFiltrada = [];

            var tamanho = Math.min(24, this.popLocalizarVeiculosProximos.listaPosicaoVeiculos.length);
            for (i = 0; i < tamanho; i++) {
                listaPosicaoVeiculosFiltrada.push(this.popLocalizarVeiculosProximos.listaPosicaoVeiculos[distances[i].marker1]);
                listaPlacasVeiculosFiltrada.push(this.popLocalizarVeiculosProximos.listaPlacasVeiculos[distances[i].marker1]);
            }

            this.popLocalizarVeiculosProximos.listaPosicaoVeiculos = listaPosicaoVeiculosFiltrada;
            this.popLocalizarVeiculosProximos.listaPlacasVeiculos = listaPlacasVeiculosFiltrada;

            var service = new window.google.maps.DistanceMatrixService();
            service.getDistanceMatrix({
                origins: [localizacaoMarker],
                destinations: this.popLocalizarVeiculosProximos.listaPosicaoVeiculos,
                travelMode: window.google.maps.TravelMode.DRIVING,
                unitSystem: window.google.maps.UnitSystem.METRIC,
                avoidHighways: false,
                durationInTraffic: false,
                avoidTolls: false
            }, self_.callbackMatrizDirecao);
        },
        callbackMatrizDirecao(response, status) {
            if (status !== window.google.maps.DistanceMatrixStatus.OK) {
                window.alert('Error was: ' + status);
            } else {
                var origins = response.originAddresses;

                var resultadoInnerHTML = '';
                var i = 0;
                var j = 0;
                for (i = 0; i < origins.length; i++) {
                    var results = response.rows[i].elements;
                    for (j = 0; j < results.length; j++) {
                        results[j].placa = this.popLocalizarVeiculosProximos.listaPlacasVeiculos[j];
                    }

                    results.sort(function (a, b) { return parseFloat(a.duration.value) - parseFloat(b.duration.value) });

                    for (j = 0; j < results.length; j++) {
                        resultadoInnerHTML += '<b>' + results[j].placa + '</b>: ' + results[j].distance.text + ' - ' + results[j].duration.text + '<br>';
                    }
                }

                var contentString = '<div id="content" style="width:300px"><div id="siteNotice"></div>' + resultadoInnerHTML + '</div>';

                let self_ = this;

                if (self_.popLocalizarVeiculosProximos.infowindowLocalizar === null) {
                    self_.popLocalizarVeiculosProximos.infowindowLocalizar = new window.google.maps.InfoWindow({
                        pixelOffset: new window.google.maps.Size(0, -12)
                    });

                    window.google.maps.event.addListener(self_.popLocalizarVeiculosProximos.infowindowLocalizar, 'closeclick', function () {
                        self_.popLocalizarVeiculosProximos.infowindowLocalizar = null;
                        self_.popLocalizarVeiculosProximos.markerInfowindowLocalizar.setMap(null);
                        self_.popLocalizarVeiculosProximos.markerInfowindowLocalizar = null;
                    });
                }

                self_.popLocalizarVeiculosProximos.infowindowLocalizar.setContent(contentString);
                self_.popLocalizarVeiculosProximos.infowindowLocalizar.open(self_.map, self_.popLocalizarVeiculosProximos.markerInfowindowLocalizar);
            }
        },
        exibirMarkerLocalizarEndereco() {
            if (this.popLocalizarVeiculosProximos.markerInfowindowLocalizar != null) {
                this.popLocalizarVeiculosProximos.markerInfowindowLocalizar.setMap(null);
                this.popLocalizarVeiculosProximos.markerInfowindowLocalizar = null;
            }

            this.popLocalizarVeiculosProximos.exibir = false;

            var localizacaoMarker = this.$refs.gmc.getLatLng(this.popLocalizarVeiculosProximos.enderecoSelecionado.latitude, this.popLocalizarVeiculosProximos.enderecoSelecionado.longitude);

            this.mostrarInfowindowComDistancias(localizacaoMarker);

        },
        localizarEndereco(pEndereco) {

            this.$vs.loading();
            const url = `https://photon.concept.inf.br/api/?q=${pEndereco}&limit=5`;

            axios.get(url, {
                credentials: 'omit', responseEncoding: 'iso88591', withCredentials: false, dataType: "json"
            })
                .then(response => {
                    this.$vs.loading.close();
                    if (response.data.hasOwnProperty('features') && response.data.features.length > 0) {
                        this.popLocalizarVeiculosProximos.listaEnderecos = response.data.features.map(element => {
                            var endereco = '';
                            if (element.properties.name) { endereco = endereco + (endereco != '' ? ", " : "") + element.properties.name; }
                            if (element.properties.street) { endereco = endereco + (endereco != '' ? ", " : "") + element.properties.street; }
                            if (element.properties.city) { endereco = endereco + (endereco != '' ? ", " : "") + element.properties.city; }
                            if (element.properties.state) { endereco = endereco + (endereco != '' ? ", " : "") + element.properties.state; }
                            if (element.properties.postcode) { endereco = endereco + (endereco != '' ? ", " : "") + element.properties.postcode; }
                            return { endereco: endereco, latitude: element.geometry.coordinates[1], longitude: element.geometry.coordinates[0] };
                        });
                    } else {
                        this.localizarEnderecoNoGoogle(pEndereco);
                    }
                })
                .catch((erro) => {
                    /* eslint-disable no-console */  console.log(erro);
                    this.$vs.loading.close();
                })
        },
        localizarEnderecoNoGoogle(pEndereco) {

            const params = new URLSearchParams();        
            params.append('pEndereco', pEndereco);

            axios.post("/rest/Geocoding/Geocode", params, { credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
            .then(result => {
                    this.$vs.loading.close();
                    if (result.data && result.data.RespostaGoogleMaps && result.data.RespostaGoogleMaps.results) {
                        let enderecoEncontrado;
                        if (Array.isArray(result.data.RespostaGoogleMaps.results)) {
                            enderecoEncontrado = result.data.RespostaGoogleMaps.results[0];
                        } else {
                            enderecoEncontrado = result.data.RespostaGoogleMaps.results;
                        }	                  
                        this.popLocalizarVeiculosProximos.enderecoSelecionado = {
                            endereco: enderecoEncontrado.formattedAddress,
                            latitude: enderecoEncontrado.geometry.location.lat, longitude: enderecoEncontrado.geometry.location.lng
                        };
                        this.exibirMarkerLocalizarEndereco()
                    } else {
                        this.popLocalizarVeiculosProximos.exibirMensagem = true;
                        this.popLocalizarVeiculosProximos.mensagem = "Endereço não encontrado."
                    }
                })
                .catch((erro) => {
                    /* eslint-disable no-console */  console.log(erro);
                    this.$vs.loading.close();
                })
        },
        localizarEnderecoNoGoogle2(pEndereco) {

            const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${pEndereco}&key=AIzaSyCbsfUVkYrj68dQW5ERabarQT4ROD9nplg`;

            axios.get(url, {
                credentials: 'omit', responseEncoding: 'iso88591', withCredentials: false, dataType: "json"
            })
                .then(response => {
                    this.$vs.loading.close();
                    if (response.data.hasOwnProperty('results') && response.data.results && response.data.results.length > 0 && response.data.results[0].hasOwnProperty('formatted_address')) {
                        this.popLocalizarVeiculosProximos.enderecoSelecionado = {
                            endereco: response.data.results[0].formatted_address,
                            latitude: response.data.results[0].geometry.location.lat, longitude: response.data.results[0].geometry.location.lng
                        };
                        this.exibirMarkerLocalizarEndereco()
                    } else {
                        this.popLocalizarVeiculosProximos.exibirMensagem = true;
                        this.popLocalizarVeiculosProximos.mensagem = "Endereço não encontrado."
                    }
                })
                .catch((erro) => {
                    /* eslint-disable no-console */  console.log(erro);
                    this.$vs.loading.close();
                })
        },        
        getDataUltimaAtualizacao(dataObj) {
            return (dataObj.dataUltimaAtualizacaoFmt2 != "null" ? dataObj.dataUltimaAtualizacaoFmt2 : "-");
        },
        getCorLinha(dataObj) {
            if (dataObj) {
                var arrayCores = this.corLocalidades.filter(function (cor) {
                    return cor.localidade == dataObj.cidadeAtual.toUpperCase();
                });

                if (arrayCores != null && arrayCores.length > 0) {
                    if (generico.isDarkColor(arrayCores[0].corEmHexa)) {
                        return "color: #eeeeee; background-color: " + arrayCores[0].corEmHexa;
                    } else {
                        return "background-color: " + arrayCores[0].corEmHexa;
                    }
                } else {
                    return "";
                }
            }
            return "";
        },
        getTooltipSwitchEnderecoCidade() {
            if (this.switchEnderecoCidade) {
                return this.$t('Tooltipo_Exibir_Cidade');
            } else {
                return this.$t('Tooltipo_Exibir_Endereco');
            }
        },
        isMovendo(dataObj) {
            return (dataObj.ignicao == 'LIGADO' ? (parseInt(dataObj.velocidadeAtual) > 0 ? true : false) : false);
        },
        getLabelVelocidadeEParado(dataObj) {
            return (dataObj.ignicao == 'LIGADO' ? (parseInt(dataObj.velocidadeAtual) > 0 ? dataObj.velocidadeAtual + ' km/h' : dataObj.tempoParado) : dataObj.tempoParado);
        },
        getCorDivisao(dataObj) {
            if (dataObj.divisaoVeiculo != "OUTRO") {
                return dataObj.corNomeDivisao;
            } else {
                return "";
            }
        },
        getCorAtivoInativo(status) {
            if (status) {
                return "rgb(70, 150, 0)";
            } else {
                return "rgb(255,15,15)";
            }
        },
        getCor2AtivoInativo(status) {
            if (status) {
                return "rgb(95, 219, 167)";
            } else {
                return "rgb(128,128,128)";
            }
        },
        getLabelSensor(dataObj) {
            let textoRetorno = "";
            textoRetorno = textoRetorno + "<p onclick=\"click_ExibiVeiculo('" + dataObj.placa + "')\" style='font-size:small;'>" + (dataObj.sensorRS232 ? dataObj.sensorRS232 : "") + "</p>";

            if (dataObj.hasOwnProperty("nivelBateriaModulo")) {
                textoRetorno = textoRetorno + "<p onclick=\"click_ExibiVeiculo('" + dataObj.placa + "')\" style='font-size:small;'>Bat: " + dataObj.nivelBateriaModulo + "%</p>";
            }

            if (dataObj.hasOwnProperty("nivelBateriaModuloBkp")) {
                textoRetorno = textoRetorno + "<p onclick=\"click_ExibiVeiculo('" + dataObj.placa + "')\" style='font-size:small;'>Bat Bkp: " + dataObj.nivelBateriaModuloBkp + "%</p>";
            }
            return textoRetorno;
        },
        getLabelDadosPlaca(dataObj) {
            if (dataObj.hasOwnProperty('labelVeiculo')) {
                return "<p onclick=\"click_ExibiVeiculo('" + dataObj.placa + "')\" style='font-size:small; font-weight: 500'>" + dataObj.labelVeiculo + "</p>" + "<p style='font-size:x-small'>" + (parseInt(dataObj.ultimoOdometroBkp) > 0 ? '[KM1: ' + generico.formatar2Digitos(parseInt(dataObj.ultimoOdometro) / 1000) + '] [KM2: ' + generico.formatar2Digitos(parseInt(dataObj.ultimoOdometroBkp) / 1000) + ']' : 'KM: ' + generico.formatar2Digitos(parseInt(dataObj.ultimoOdometro) / 1000)) + "</p>";
            } else {
                return "<p onclick=\"click_ExibiVeiculo('" + dataObj.placa + "')\" style='font-size:small; font-weight: 500'>" + dataObj.placa + "</p>" + "<p style='font-size: x-small'>" + (parseInt(dataObj.ultimoOdometroBkp) > 0 ? '[KM1: ' + generico.formatar2Digitos(parseInt(dataObj.ultimoOdometro) / 1000) + '] [KM2: ' + generico.formatar2Digitos(parseInt(dataObj.ultimoOdometroBkp) / 1000) + ']' : 'KM: ' + generico.formatar2Digitos(parseInt(dataObj.ultimoOdometro) / 1000)) + "</p>";
            }
        },
        getLabelDadosDivisao(dataObj) {
            if (dataObj.divisaoVeiculo != "OUTRO") {
                return "<p style='font-size:small; color: " + dataObj.corNomeDivisao + "' onclick=\"click_ExibiVeiculo('" + dataObj.placa + "')\" >" + dataObj.divisaoVeiculo + "</p>" + "<p onclick=\"click_ExibiVeiculo('" + dataObj.placa + "')\" style='color: " + dataObj.corNomeDivisao + "'>" + dataObj.modelo + "</p>";
            } else {
                return "<p style='font-size:small' onclick=\"click_ExibiVeiculo('" + dataObj.placa + "')\" >" + dataObj.modelo + "</p>";
            }
        },
        getDadosVeiculo(veiculo) {
            if (veiculo.divisaoVeiculo != "OUTRO") {
                return "[ " + veiculo.divisaoVeiculo + " ] " + veiculo.modelo + " " + veiculo.placa + " " + (veiculo.hasOwnProperty("labelVeiculo") ? veiculo.labelVeiculo : "");
            } else {
                return veiculo.modelo + " " + veiculo.placa + " " + (veiculo.hasOwnProperty("labelVeiculo") ? veiculo.labelVeiculo : "");
            }
        },
        getLabelLocalizacao(dataObj) {
            if (dataObj.hasOwnProperty("poi")) {
                return dataObj.poi;
            } else {
                if (this.switchEnderecoCidade) {
                    return dataObj.enderecoAtual;
                } else {
                    return dataObj.cidadeAtual.toUpperCase();
                }
            }
        },
        click_ExibiVeiculo(placaSelecionada) {
            var marcadores = this.$refs.gmc.getMarcadores();

            if (marcadores.length > 0) {

                for (var i = 0; i < marcadores.length; i++) {
                    if (marcadores[i].getTitle() == placaSelecionada) {
                        this.map.setZoom(20);
                        this.map.panTo(marcadores[i].getPosition());
                        window.google.maps.event.trigger(marcadores[i], 'click');
                        break;
                    }
                }
            }

        },
        inicializarMarcadores() {
            this.listaVeiculos.forEach((veiculo) => {
                if (veiculo.hasOwnProperty("latitude") && veiculo.hasOwnProperty("longitude")) {
                    this.mostrarVeiculoNoMapa(veiculo);
                }
            });

            this.pollingIntervalObj = setInterval(() => {
                this.atualizarTodosVeiculosNoMapa();
            }, 5000);
        },
        mostrarVeiculoNoMapa(veiculo) {

            var isVisible = true;

            var marcadores = this.$refs.gmc.getMarcadores();

            if (marcadores.length > 0) {
                var indiceEncontrado = -1;
                for (var i = 0; i < marcadores.length; i++) {
                    if (marcadores[i].getTitle() === veiculo.placa) {
                        marcadores[i].setMap(null);
                        isVisible = marcadores[i].getVisible();
                        indiceEncontrado = i;
                        this.mc.removeMarker(marcadores[i], false);
                    }
                }

                if (indiceEncontrado > -1) {
                    marcadores.splice(indiceEncontrado, 1); // Removendo marker do array                }
                }
            }

            var lastAdderMarker = null;
            if (veiculo.ignicao == "LIGADO") {
                if (veiculo.velocidade > 0) {
                    lastAdderMarker = this.addMarkerVeiculoPlaca(veiculo, "labelLigadoEmMovimento", veiculo.velocidadeAtual + " KM/h", veiculo.orientacao);
                } else {
                    lastAdderMarker = this.addMarkerVeiculoPlaca(veiculo, "labelLigadoEmParado", "Parado por " + veiculo.tempoParado, veiculo.orientacao);
                }
            } else {
                lastAdderMarker = this.addMarkerVeiculoPlaca(veiculo, "labelDesligado", "Parado por " + veiculo.tempoParado, 0);
            }
            if (lastAdderMarker != null) {
                if (!isVisible) {
                    lastAdderMarker.setVisible(isVisible);
                    this.mc.removeMarker(lastAdderMarker, false);
                } else {
                    this.mc.addMarker(lastAdderMarker, false);
                }

                if (veiculo.hasOwnProperty("exibirAlertaTempoParado")) {
                    lastAdderMarker.setAnimation(window.google.maps.Animation.BOUNCE);
                }
            }
        },
        addMarkerVeiculoPlaca(veiculo, classeCss, tempoParadaOuVelocidade, rotacao) {

            if (!veiculo.hasOwnProperty("latitude") || !veiculo.hasOwnProperty("longitude")) {
                return null;
            }

            var dadosVeiculo = veiculo.marca + " " + veiculo.modelo;
            var icone = this.publicPath + "imagens/iconesCarros/icone" + veiculo.tipoVeiculo;
            var location = this.$refs.gmc.getLatLng(veiculo.latitude, veiculo.longitude);
            var placa = veiculo.placa;
            var condutorVeiculo = veiculo.condutor;
            var ignicao = veiculo.ignicao
            var dataAtualizacao = veiculo.dataUltimaAtualizacaoFmt2;
            var statusGPRS = veiculo.statusGPRS;
            var labelVeiculo = veiculo.labelVeiculo;
            var enderecoAtual = veiculo.enderecoAtual;

            if (!labelVeiculo || labelVeiculo == null || labelVeiculo.length == 0) {
                labelVeiculo = placa;
            }
            var marker1 = new window.MarkerWithLabel({
                position: location,
                title: placa,
                map: this.map,
                labelContent: labelVeiculo,
                labelAnchor: this.getLevelAnchor(rotacao, ignicao, icone, labelVeiculo.length),
                labelClass: classeCss,
                labelStyle: { opacity: 1 },
                icon: { url: this.getIconeByRotacao(rotacao, icone, ignicao) }
            });

            var marcadores = this.$refs.gmc.getMarcadores();
            marcadores.push(marker1);
            let self_ = this;

            window.google.maps.event.addListener(marker1, 'click', function (event) {
                /* eslint-disable no-console */  console.log(event);
                var contentStringInfowindow = self_.listaContentStringInfowindow.get(marker1.getTitle());

                if (contentStringInfowindow != null && contentStringInfowindow != "") {
                    self_.abrirInfowindow(marker1, contentStringInfowindow);
                } else {
                    self_.listaContentStringInfowindow.set(marker1.getTitle(), self_.montarContentStringInfoWindow(dadosVeiculo, condutorVeiculo, tempoParadaOuVelocidade, ignicao, dataAtualizacao, statusGPRS, enderecoAtual, marker1));
                    self_.abrirInfowindow(marker1, self_.listaContentStringInfowindow.get(marker1.getTitle()));
                }
            });

            if (this.markerInfowindow != null) {
                if (marker1.getTitle() == this.markerInfowindow.getTitle()) {
                    window.google.maps.event.trigger(marker1, 'click');
                }
            }

            return marker1;
        },
        getLevelAnchor(rotacao, ignicao, pathIcone, qtdCaracterLabel) {
            var posX = qtdCaracterLabel * 4.5;
            if (ignicao == "DESLIGADO") {
                rotacao = 90;
            }
            var posY = this.getPosY(pathIcone, rotacao);

            return new window.google.maps.Point(posX, posY);
        },
        getPosY(pathIcone, rotacao) {
            pathIcone = pathIcone.toUpperCase();
            if ((rotacao >= 0 && rotacao < 90) || (rotacao > 90 && rotacao < 270) || (rotacao > 270 && rotacao <= 359)) {
                if (pathIcone.indexOf('iconeCaminhao2Bau'.toUpperCase()) != -1) { return 47; }
                if (pathIcone.indexOf('iconeCaminhaoA'.toUpperCase()) != -1) { return 57; }
                if (pathIcone.indexOf('iconeCaminhaoBauGrande'.toUpperCase()) != -1) { return 63; }
                if (pathIcone.indexOf('iconeCaminhaoBau'.toUpperCase()) != -1) { return 47; }
                if (pathIcone.indexOf('iconeCaminhaoC'.toUpperCase()) != -1) { return 55; }
                if (pathIcone.indexOf('iconeCarroC'.toUpperCase()) != -1) { return 55; }
                if (pathIcone.indexOf('iconeCarro'.toUpperCase()) != -1) { return 55; }
                if (pathIcone.indexOf('iconeCarreta'.toUpperCase()) != -1) { return 63; }
                if (pathIcone.indexOf('iconeGuincho'.toUpperCase()) != -1) { return 67; }
                if (pathIcone.indexOf('iconeLancha'.toUpperCase()) != -1) { return 57; }
                if (pathIcone.indexOf('iconeMoto'.toUpperCase()) != -1) { return 51; }
                if (pathIcone.indexOf('iconeOnibus'.toUpperCase()) != -1) { return 57; }
                if (pathIcone.indexOf('iconePickup'.toUpperCase()) != -1) { return 62; }
                if (pathIcone.indexOf('iconePortatil'.toUpperCase()) != -1) { return 40; }
                if (pathIcone.indexOf('iconeRetroescavadeira'.toUpperCase()) != -1) { return 63; }
                if (pathIcone.indexOf('iconeRolocompressor'.toUpperCase()) != -1) { return 59; }
                if (pathIcone.indexOf('iconeVan'.toUpperCase()) != -1) { return 66; }
                if (pathIcone.indexOf('iconeVeiculo'.toUpperCase()) != -1) { return 52; }
                if (pathIcone.indexOf('iconePlataforma'.toUpperCase()) != -1) { return 64; }
            } else {
                if (pathIcone.indexOf('iconeCaminhao2Bau'.toUpperCase()) != -1) { return 35; }
                if (pathIcone.indexOf('iconeCaminhaoA'.toUpperCase()) != -1) { return 39; }
                if (pathIcone.indexOf('iconeCaminhaoBauGrande'.toUpperCase()) != -1) { return 35; }
                if (pathIcone.indexOf('iconeCaminhaoBau'.toUpperCase()) != -1) { return 35; }
                if (pathIcone.indexOf('iconeCaminhaoC'.toUpperCase()) != -1) { return 40; }
                if (pathIcone.indexOf('iconeCarroC'.toUpperCase()) != -1) { return 35; }
                if (pathIcone.indexOf('iconeCarro'.toUpperCase()) != -1) { return 35; }
                if (pathIcone.indexOf('iconeCarreta'.toUpperCase()) != -1) { return 35; }
                if (pathIcone.indexOf('iconeGuincho'.toUpperCase()) != -1) { return 40; }
                if (pathIcone.indexOf('iconeLancha'.toUpperCase()) != -1) { return 39; }
                if (pathIcone.indexOf('iconeMoto'.toUpperCase()) != -1) { return 40; }
                if (pathIcone.indexOf('iconeOnibus'.toUpperCase()) != -1) { return 55; }
                if (pathIcone.indexOf('iconePickup'.toUpperCase()) != -1) { return 35; }
                if (pathIcone.indexOf('iconePortatil'.toUpperCase()) != -1) { return 40; }
                if (pathIcone.indexOf('iconeRetroescavadeira'.toUpperCase()) != -1) { return 39; }
                if (pathIcone.indexOf('iconeRolocompressor'.toUpperCase()) != -1) { return 45; }
                if (pathIcone.indexOf('iconeVan'.toUpperCase()) != -1) { return 40; }
                if (pathIcone.indexOf('iconeVeiculo'.toUpperCase()) != -1) { return 32; }
                if (pathIcone.indexOf('iconePlataforma'.toUpperCase()) != -1) { return 55; }
            }

            return 35;
        },
        getIconeByRotacao(rotacao, pathIcone, ignicao) {
            if (ignicao == "DESLIGADO") {
                return pathIcone = pathIcone + '90.png';
            }

            if (rotacao >= 0 && rotacao <= 22.5) {
                return pathIcone = pathIcone + '0.png';
            } else if (rotacao > 22.5 && rotacao <= 67.5) {
                return pathIcone = pathIcone + '45.png';
            } else if (rotacao > 67.5 && rotacao <= 112.5) {
                return pathIcone = pathIcone + '90.png';
            } else if (rotacao > 112.5 && rotacao <= 157.5) {
                return pathIcone = pathIcone + '135.png';
            } else if (rotacao > 157.5 && rotacao <= 202.5) {
                return pathIcone = pathIcone + '180.png';
            } else if (rotacao > 202.5 && rotacao <= 247.5) {
                return pathIcone = pathIcone + '215.png';
            } else if (rotacao > 247.5 && rotacao <= 292.5) {
                return pathIcone = pathIcone + '270.png';
            } else if (rotacao > 292.5 && rotacao <= 337.5) {
                return pathIcone = pathIcone + '315.png';
            } else if (rotacao > 337.5) {
                return pathIcone = pathIcone + '0.png';
            }

            return pathIcone = pathIcone + '0.png';
        },
        abrirInfowindow(marcador, contentString) {
            if (this.infowindow == null) {
                this.infowindow = new window.google.maps.InfoWindow({
                    pixelOffset: new window.google.maps.Size(0, -15),
                });

                let self_ = this;

                window.google.maps.event.addListener(this.infowindow, 'closeclick', function () {
                    //flexApp.deselecionarVeiculoJS();                    
                    self_.listaContentStringInfowindow.set(marcador.getTitle(), "");
                    self_.markerInfowindow = null;
                });
            }

            this.infowindow.setContent(contentString);
            this.infowindow.open(this.map, marcador);

            this.markerInfowindow = null;
            this.markerInfowindow = marcador;
            //flexApp.selecionarVeiculoGrid(marcador.getTitle());
        },
        montarContentStringInfoWindow(dadosVeiculo, condutorVeiculo, tempoParadaOuVelocidade, ignicao, dataAtualizacao, statusGPRS, enderecoAtual, marcador) {
            var contentString = '<div id="content" style="width:300px">' +
                '<p style="color: #000000; font-weight: bold" id="divDadosVeiculo">' + dadosVeiculo + '</p>' +
                '<div id="bodyContent">' +
                '<div class="section 1">'
                + '<p id="pCondutorVeiculo">' + condutorVeiculo + '</p>'
                + '<p class="right">GPRS: &nbsp;&nbsp;&nbsp; <span id="spanGPRS" class="glyphicon glyphicon-signal ' + statusGPRS + '" title="' + statusGPRS + '"></span></p>' +
                '</div>' +
                '<div class="section 2">' +
                ' <p id="pTempoParadaOuVelocidade">' + tempoParadaOuVelocidade + '</p>' +
                ' <p class="right">Igni&ccedil;&atilde;o: <span id="spanIgnicao" class="glyphicon glyphicon-cog ' + ignicao + '" title="' + ignicao + '"></span></p>' +
                '</div>' +
                ' <p class="lblEndereco"> <span style="padding:4px;" class="glyphicon glyphicon-map-marker"> </span> <span id="divEndereco">' + enderecoAtual + '</span> </p>' +
                '<div class="sectionRM">' +
                ' <button title="Street View" onclick="' + this.getClickExibirStreetView(marcador) + '"><span style="padding:4px;" class="glyphicon glyphicon-road"> </span></button> ' +                
                ' <button title="Percurso" onclick="click_RoutePercurso(\'' + marcador.getTitle() + '\')"><span style="padding:4px;" class="glyphicon glyphicon-retweet"> </span></button> ';
            if (this.$store.state.AppActiveUser.idEmpresa === 1) {
                contentString = contentString + ' <button title="Percurso em nova aba" onclick="click_RoutePercursoNovaWindow(\'' + marcador.getTitle() + '\')"><span style="padding:4px; color: blue" class="glyphicon glyphicon-retweet"> </span></button> ';
            }

            contentString = contentString + ' <button title="Abrir no Google Maps" onclick="' + this.getClickAbrirGoogleMaps(marcador) + '"><span style="padding:4px;" class="glyphicon glyphicon-search"> </span></button> ' +
                ' <span class="lblDataAtualizacao" id="divDataAtualizacao"> Atualizado: ' + dataAtualizacao + '</span>' +
                '</div>' +
                '</div>' +
                '</div>';

            return contentString;
        },
        getClickAbrirGoogleMaps(marcador) {
            return "window.open('https://www.google.com/maps/search/?api=1&query=" + marcador.getPosition().lat() + "," + marcador.getPosition().lng() + "', '_blank')";
        },
        getClickExibirStreetView(marcador) {
            return "window.open('https://www.google.com/maps/@?api=1&map_action=pano&heading=-45&viewpoint=" + marcador.getPosition().lat() + "," + marcador.getPosition().lng() + "','_blank')";
        },
        alterarVeiculoNoMapa(veiculo, pExibirRastro) {
            var latitude = veiculo.latitude;
            var longitude = veiculo.longitude;
            var placa = veiculo.placa;
            var velocidade = veiculo.velocidadeAtual;
            var dadosVeiculo = veiculo.marca + " " + veiculo.modelo;
            var icone = this.publicPath + "imagens/iconesCarros/icone" + veiculo.tipoVeiculo;
            var tempoParada = veiculo.tempoParado;
            var rotacao = veiculo.orientacao;
            var exibirAlertaTempoParado = veiculo.hasOwnProperty("exibirAlertaTempoParado");
            var exibirRastro = pExibirRastro;
            var condutorVeiculo = veiculo.condutor;
            var ignicao = veiculo.ignicao;
            var dataAtualizacao = veiculo.dataUltimaAtualizacaoFmt2;
            var statusGPRS = veiculo.statusGPRS;
            var enderecoAtual = veiculo.enderecoAtual;

            if (typeof this.$refs.gmc.getMarcadores() === 'undefined') {
                this.$store.commit("APAGAR_USUARIO_LOGADO");
                this.$router.push({ path: '/login' })
            }
            var marcadores = this.$refs.gmc.getMarcadores();

            if (marcadores.length > 0) {

                for (var i = 0; i < marcadores.length; i++) {
                    if (marcadores[i].getTitle() === placa) {
                        var tempoParadaOuVelocidade = "";
                        marcadores[i].setIcon(this.getIconeByRotacao(rotacao, icone, ignicao, velocidade));
                        marcadores[i].labelAnchor = this.getLevelAnchor(rotacao, ignicao, icone, marcadores[i].labelContent.length);
                        if (ignicao == "LIGADO") {
                            if (velocidade > 0) {
                                marcadores[i].labelClass = "labelLigadoEmMovimento";
                                tempoParadaOuVelocidade = velocidade + " KM/h";
                            } else {
                                marcadores[i].labelClass = "labelLigadoEmParado";
                                tempoParadaOuVelocidade = "Parado por " + tempoParada;
                            }
                        } else {
                            marcadores[i].labelClass = "labelDesligado";
                            tempoParadaOuVelocidade = "Parado por " + tempoParada;
                        }

                        var latlng = this.$refs.gmc.getLatLng(parseFloat(latitude), parseFloat(longitude));
                        ///* eslint-disable no-console */  console.log('Exibir Rastro do ' + marcadores[i].getTitle() + ' = ' + exibirRastro);                            
                        if (exibirRastro) {
                            if (!this.listaRastros.has(marcadores[i].getTitle())) {
                                this.listaRastros.set(marcadores[i].getTitle(), new Array());
                                ///* eslint-disable no-console */  console.log('Criou Array Poly o item = ' + marcadores[i].getTitle());
                            }
                            // Desenhar Rastro
                            var coordenadas = new Array();
                            coordenadas.push(marcadores[i].getPosition());
                            coordenadas.push(latlng);
                            var linhaRastro = new window.google.maps.Polyline({
                                path: coordenadas,
                                geodesic: true,
                                strokeColor: '#FF0000',
                                strokeOpacity: 1.0,
                                strokeWeight: 2
                            });

                            linhaRastro.setMap(this.map);
                            this.listaRastros.get(marcadores[i].getTitle()).push(linhaRastro);
                            // Fim Desenho Rastro.
                        } else {

                            if (this.listaRastros.has(marcadores[i].getTitle())) {
                                // /* eslint-disable no-console */  console.log('Apagando o rastro de ' + marcadores[i].getTitle());
                                var listaPoly = this.listaRastros.get(marcadores[i].getTitle());
                                // /* eslint-disable no-console */  console.log('Achou a lista ' + listaPoly);
                                var item;
                                while (listaPoly.length > 0) {
                                    item = listaPoly.pop();
                                    item.setMap(null);
                                    // /* eslint-disable no-console */  console.log('Apagou o item' + listaPoly);
                                }
                                this.listaRastros.delete(marcadores[i].getTitle());
                                this.listaRastros = null;
                                this.listaRastros = new Map();
                            }
                        }

                        marcadores[i].setPosition(latlng);
                        try {
                            if (marcadores[i].label.getProjection() != null) {
                                marcadores[i].label.setStyles();
                            }
                        } catch (e) { /* eslint-disable no-console */  console.log(e) }

                        if (exibirAlertaTempoParado) {
                            marcadores[i].setAnimation(window.google.maps.Animation.BOUNCE);
                        }

                        if (this.markerInfowindow != null && marcadores[i].getTitle() == this.markerInfowindow.getTitle() && document.getElementById("pCondutorVeiculo")) {
                            document.getElementById("pCondutorVeiculo").innerHTML = "<p>" + condutorVeiculo + "</p>";
                            document.getElementById("pTempoParadaOuVelocidade").innerHTML = "<p>" + tempoParadaOuVelocidade + "</p>";
                            document.getElementById("divDataAtualizacao").innerText = "Atualizado às " + dataAtualizacao;
                            document.getElementById("spanGPRS").className = "glyphicon glyphicon-signal " + statusGPRS;
                            document.getElementById("spanGPRS").title = statusGPRS;
                            document.getElementById("spanIgnicao").className = "glyphicon glyphicon-cog " + ignicao;
                            document.getElementById("spanIgnicao").title = ignicao;
                            document.getElementById("divEndereco").innerText = veiculo.enderecoAtual;
                        }

                        this.listaContentStringInfowindow.set(marcadores[i].getTitle(), this.montarContentStringInfoWindow(dadosVeiculo, condutorVeiculo, tempoParadaOuVelocidade, ignicao, dataAtualizacao, statusGPRS, enderecoAtual, marcadores[i]));

                        return;
                    }
                }
            }
        },
        atualizarTodosVeiculosNoMapa() {
            var exibirRastro = false;

            this.listaVeiculos.forEach((veiculo) => {
                if (veiculo.latitude && veiculo.longitude) {
                    exibirRastro = this.carroSelecionadoNoGrid.indexOf(veiculo.placa) !== -1;
                    this.alterarVeiculoNoMapa(veiculo, exibirRastro);
                }
            });
        },
        exibirVeiculosListados() {
            var marcadores = this.$refs.gmc.getMarcadores();

            if (marcadores.length > 0) {
                var markerSelecionado = null;
                var bounds = null;
                var i = 0;
                for (i = 0; i < marcadores.length; i++) {
                    marcadores[i].setVisible(false);
                    this.mc.removeMarker(marcadores[i], false);
                }

                for (i = 0; i < marcadores.length; i++) {
                    for (var j = 0; j < this.filteredVeiculos.length; j++) {
                        if (marcadores[i].getTitle() == this.filteredVeiculos[j].placa) {
                            marcadores[i].setVisible(true);
                            if (bounds == null) {
                                bounds = new window.google.maps.LatLngBounds();
                            }
                            bounds.extend(marcadores[i].getPosition());
                            this.markerSelecionado = marcadores[i];
                            this.mc.addMarker(marcadores[i], false);
                        }
                    }
                }
                if (bounds !== null) {
                    this.map.fitBounds(bounds);
                    this.map.panToBounds(bounds);
                }

                if (this.infowindow != null) {
                    this.infowindow.close();
                    this.infowindow = null;
                    this.markerInfowindow = null;
                }

            }
            if (this.filteredVeiculos.length == 1 && this.markerSelecionado != null && this.markerInfowindow != null) {
                window.google.maps.event.trigger(markerSelecionado, 'click');
            }
        },
        print() {
            //const el = this.$refs.divMap;
            const el = document.querySelector('#map > div:first-of-type');

            const options = {
                type: 'dataURL',
                useCORS: true,
                optimized: false,
                allowTaint: false,
                async: false,
                ignoreElements: (node) => {
                    return node.nodeName === 'IFRAME';
                }
            }
            this.$html2canvas(el, options).then(canvas => {
                const url = canvas;
                var fileLink = document.createElement('a');
                fileLink.href = url;
                fileLink.setAttribute('download', 'mapa.png');
                document.body.appendChild(fileLink);
                fileLink.click();
                window.URL.revokeObjectURL(url);
                fileLink.remove();
            });
        },
        criarBotaoImprimir() {

            var controlUI = this.criarBotaoGenerico(this.botaoImprimirDiv, 'Clique para imprimir o mapa', null, 'imagens/iconesMapa/imprimir.png');
            let self_ = this;
            window.google.maps.event.addDomListener(controlUI, 'click', function () {
                //window.print();
                self_.print()
            });
        },
        criarBotaoVerTodos() {
            let self_ = this;

            var controlUI = this.criarBotaoGenerico(this.botaoVerTodosDiv, 'Clique para ver todos os veiculos', null, 'imagens/iconesMapa/vertodos.png');

            window.google.maps.event.addDomListener(controlUI, 'click', function () {
                self_.exibirVeiculosListados();
            });
        },
        criarBotaoLocalizarEndereco() {
            let self_ = this;

            var controlUI = this.criarBotaoGenerico(this.botaoLocalizarEnderecoDiv, 'Clique para localizar um endereço e ver os veiculos mais proximos', null, 'imagens/iconesMapa/localizar.png');

            window.google.maps.event.addDomListener(controlUI, 'click', function () {
                self_.popLocalizarVeiculosProximos.exibir = true;
                self_.popLocalizarVeiculosProximos.listaEnderecos = [];
                self_.$refs.txtEndereco.value = "";
            });
        },
        criarBotaoOcultarGrid() {
            let self_ = this;

            var controlUI = this.criarBotaoGenerico(this.botaoOcultarGridDiv, 'Clique para exibir/ocultar Grid', null, 'imagens/iconesMapa/exibirocultar.png');

            window.google.maps.event.addDomListener(controlUI, 'click', function () {
                self_.exibirGrid = !self_.exibirGrid;
            });
        },       
        hide(elements) {
            elements = elements.length ? elements : [elements];
            for (var index = 0; index < elements.length; index++) {
                elements[index].style.display = 'none';
            }
        },
        show(elements) {
            elements = elements.length ? elements : [elements];
            for (var index = 0; index < elements.length; index++) {
                elements[index].style.display = 'block';
            }
        },
        imprimirGrid() {

            var form = document.createElement("form");
            form.target = "_blank";
            form.method = "POST";
            form.action = axios.defaults.baseURL + '/print/printGrid.jsp';
            form.style.display = "none";

            var input1 = document.createElement("input");
            input1.type = "hidden";
            input1.name = "titulo1";
            input1.value = this.$store.state.AppActiveUser.nomeCentral;
            form.appendChild(input1);

            var input2 = document.createElement("input");
            input2.type = "hidden";
            input2.name = "titulo2";
            input2.value = " > Grid de Veículos";
            form.appendChild(input2);

            var listaDados = document.createElement("input");
            listaDados.type = "hidden";
            listaDados.name = "listaDados";
            listaDados.value = JSON.stringify(this.filteredVeiculos);
            form.appendChild(listaDados);

            document.body.appendChild(form);
            form.submit();
            document.body.removeChild(form);
        },
        criarBotaoGenerico(btnDiv, btnTooltip, btnTitulo, btnIcone) {

            if (btnDiv != null) {
                this.map.controls[window.google.maps.ControlPosition.RIGHT_TOP].removeAt(this.map.controls[window.google.maps.ControlPosition.RIGHT_TOP].getLength() - 1);
            }

            btnDiv = window.document.createElement('div');
            btnDiv.style.padding = '2px';
            btnDiv.style.width = '32px';

            // Set CSS for the control border
            var controlUI = document.createElement('div');
            controlUI.style.backgroundColor = '#fff';
            controlUI.style.border = '2px solid #fff';
            controlUI.style.borderRadius = '3px';
            controlUI.style.boxShadow = '0 2px 6px rgba(0,0,0,.3)';
            controlUI.style.cursor = 'pointer';
            controlUI.style.marginBottom = '5px';
            controlUI.style.textAlign = 'center';
            if (btnIcone) {
                controlUI.style.backgroundImage = "url(" + btnIcone + ")";
                controlUI.style.height = '25px';
                controlUI.style.width = '25px';
                controlUI.style.top = '11px';
                controlUI.style.left = '120px';
            }
            controlUI.title = btnTooltip;
            btnDiv.appendChild(controlUI);

            // Set CSS for the control interior
            if (btnTitulo) {
                var controlText = window.document.createElement('div');
                controlText.style.color = '#000000';
                controlText.style.fontFamily = 'Roboto,Arial,sans-serif';

                controlText.style.fontSize = '12px';
                controlText.style.lineHeight = '24px';
                controlText.style.paddingLeft = '5px';
                controlText.style.paddingRight = '5px';
                controlText.innerHTML = btnTitulo;
                controlUI.appendChild(controlText);
            }

            btnDiv.index = 1;
            this.map.controls[window.google.maps.ControlPosition.RIGHT_TOP].push(btnDiv);

            return controlUI;
        }
    }
}
